import * as React from 'react';
import PropTypes from 'prop-types';
import styles from '../../css/pc/PcGeneral.module.css';
import classNames from 'classnames/bind';

const cx = classNames.bind(styles);

export default function SamsungPayBox(props) {
  SamsungPayBox.propTypes = {
    children: PropTypes.array,
  };

  return(
    <div className={cx('mpi-box')}>
      {props.children}
    </div>
  );
}